<template>
  <div id="shopBanner" style="width: 100%">
    <div id="desktop">
      <patternlib-headline
        separator="none"
        :headline="$t('shopBanner.headline')"
        heading-tag="h1"
      ></patternlib-headline>
      <p style="margin-bottom: var(--spacing-5); margin-top: var(--spacing-5)">
        {{ $t('shopBanner.text') }}
      </p>
      <patternlib-button
        :label="$t('shopBanner.button')"
        type="secondary"
        size="small"
        icon-position="right"
        label-text-align="left"
        @click="redirectToShop()"
      >
        <patternlib-icon
          icon-name="font-arrow"
          size="24px"
          slot="icon"
        ></patternlib-icon>
      </patternlib-button>
    </div>

    <div id="mobile">
      <div id="mobileImage"></div>

      <div style="margin: var(--spacing-5)">
        <patternlib-headline
          separator="none"
          :headline="$t('shopBanner.headline')"
          heading-tag="h3"
        ></patternlib-headline>
        <p
          style="margin-bottom: var(--spacing-5); margin-top: var(--spacing-5)"
        >
          {{ $t('shopBanner.text') }}
        </p>
        <patternlib-button
          :label="$t('shopBanner.button')"
          type="secondary"
          size="small"
          icon-position="right"
          label-text-align="left"
          display="block"
          @click="redirectToShop()"
        >
          <patternlib-icon
            icon-name="font-arrow"
            size="24px"
            slot="icon"
          ></patternlib-icon>
        </patternlib-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { useGlobal } from '../stores/globalStore'
  export default {
    methods: {
      redirectToShop() {
        const globalStore = useGlobal()
        window.location.href = globalStore.accessoryShopUrl
      }
    }
  }
</script>

<style lang="scss" scoped>
  #desktop {
    display: block;
    background: linear-gradient(
        to left,
        rgba(0, 0, 0, 0) 400px,
        rgb(246, 242, 241) 600px,
        rgb(246, 242, 241)
      ),
      url('@/assets/img/shopBanner.png') no-repeat right;
    background-size: contain;
    width: 100%;
    padding: 80px;
    padding-right: 800px;
  }

  #desktop {
    display: none;
  }

  #mobileImage {
    height: 250px;
    width: 100%;
    background: linear-gradient(
        to left,
        rgba(0, 0, 0, 0) 80%,
        rgb(246, 242, 241) 100%
      ),
      url('@/assets/img/shopBanner.png') no-repeat right;
    background-size: cover;
  }

  @media only screen and (min-width: 1280px) {
    #desktop {
      display: block;
    }

    #mobile {
      display: none;
    }
  }
</style>
